import { UseQueryOptions, queryOptions } from '@tanstack/react-query';
import { SuggestedKeywordsParams, getSuggestedKeywords } from '~/apis/search';

export const suggestedKeywordsOptions = ({ q }: SuggestedKeywordsParams, { enabled }: Partial<UseQueryOptions>) =>
  queryOptions({
    queryKey: ['search', 'getSuggestedKeywords', q],
    queryFn: () => getSuggestedKeywords({ q }),
    select: (data) => data.data,
    enabled,
    placeholderData: (prevData) => prevData,
  });
